import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberData'
})
export class NumberDataPipe implements PipeTransform {
  transform(value: any): string {
    if (value) {
      if (typeof value === 'number') return value.toLocaleString();

      if (typeof value === 'string') {
        const parsed = parseFloat(value);
        if (isNaN(parsed)) return '0';
        return parsed.toLocaleString();
      }
    }
    return '0';
  }
}
